import React from "react";
import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
const StockMovementComponent = loadable(
  () => import("../../components/InventoryReport/StockMovement")
);
const StockMovementNormal = () => {
  const tabs = [
    {
      id: "stock-movement-normal",
      label: "Normal",
      href: "/accounting/stock-movement-normal",
    },
    {
      id: "stock-movement-group",
      label: "Grouped",
      href: "/accounting/stock-movement-group",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} /> <StockMovementComponent />
    </>
  );
};

export default StockMovementNormal;
